import { useAtom } from 'infrastructure/state/jotai.wrapper'
import React from 'react'
import RequestDialog from '../../dialogs/RequestDialog'
import {
  selectedActionAtom,
  selectedFeaturePackageAtom,
  selectedSchoolsAtom,
} from '../../../api/platformFeatures.atoms'
import { useFeaturePackageUpdate } from 'api/platformFeatures.hooks'

interface FeaturePackageConfirmProps {
  onCloseDialog: () => void
}

export const FeaturePackageConfirm = ({
  onCloseDialog,
}: FeaturePackageConfirmProps) => {
  const [selectedAction, setSelectedAction] = useAtom(selectedActionAtom)
  const [selectedSchools, setSelectedSchools] = useAtom(selectedSchoolsAtom)
  const [packageName, setSelectedPackage] = useAtom(selectedFeaturePackageAtom)

  const doUpdate = useFeaturePackageUpdate(packageName)

  if (!selectedAction) return null

  const { actionType, entityType } = selectedAction
  const schoolsList = selectedSchools.map((school) => ({
    key: school?.name || '',
  }))

  const districtChangeMessage = {
    key: `Changes to the district will affect all schools within the district.
          Please change schools individually if their settings should differ from the district.`,
  }

  const dialogContent = [
    ...(entityType === 'district' ? [districtChangeMessage] : []),
    {
      key: `Feature package to ${actionType}`,
      value: packageName,
    },
    ...(entityType === 'school'
      ? [{ key: '――――――――――――――――――' }, ...schoolsList]
      : []),
  ]

  const title = `Are you sure you want to ${actionType} the feature package ${
    actionType === 'add' ? 'to' : 'from'
  } ${entityType === 'school' ? 'the selected ' : 'this '}${entityType}?`

  const onClose = () => {
    setSelectedAction(undefined)
    setSelectedSchools([])
    setSelectedPackage('')
    onCloseDialog()
  }

  return (
    <RequestDialog
      open={true}
      title={title}
      content={dialogContent}
      submitRequest={doUpdate}
      onClose={onClose}
      refreshPopUp={false}
    />
  )
}
